export default __webpack_public_path__ + "static/media/photo--sm--90.19430ff2.jpg";